module.exports = __webpack_public_path__ + "img/p4_2.0c74e1c2.png";